<template>
  <div class="glf">
    <div class="content">
      <div class="gtitle">
        <p class="title">请选择要缴费的墓</p>
        <div>
          <van-field required v-model="form.maintainAddress" label="墓编号" placeholder="编号 或 **排**号" />
        </div>
      </div>
      <div class="line"></div>
      <div class="detailList">
        <p class="title menu">
          <span>维护费到期时间</span>
        </p>
        <p class="date"></p>
        <p class="text">请在到期前缴纳新的维护费</p>
      </div>
      <div class="line"></div>
      <div class="gtitle">
        <p class="title">请选择缴费项目</p>
        <ul class="list clearbox" style="padding-start:0">
          <template v-for="(item, index) in list">
            <li
              :key="index"
              class="hui"
              @click="xuanze(item.id, item.duration)"
              :style="duration == item.duration ? 'background:#15a892;' : ''"
            >
              <p :class="duration == item.duration ? 'name name1' : 'name'">
                {{ item.duration }}年
              </p>
              <p :class="duration == item.duration ? 'price price1' : 'price'">
                ￥{{ item.price }}
              </p>
            </li>
          </template>
          <!-- <li class="hui" @click="xuanze(20)" :style="index == 20 ? 'background:#15a892;' : ''">
            <p :class="index == 20 ? 'name name1' : 'name'">20年</p>
            <p :class="index == 20 ? 'price price1' : 'price'">￥1000</p>
          </li>
          <li class="hui" @click="xuanze(30)" :style="index == 30 ? 'background:#15a892;' : ''">
            <p :class="index == 30 ? 'name name1' : 'name'">30年</p>
            <p :class="index == 30 ? 'price price1' : 'price'">￥1500</p>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="clear-box"></div>
    <div class="footdiv">
      <div class="jiage">
        需要支付 :
        <span class="price">￥{{ money }}</span>
      </div>
      <div class="btn" @click="submitMaintain()">支付</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guanlifei',
  data() {
    return {
      place: '',
      index: 10,
      money: 0,
      form: {
        myId: this.$store.getters.userId,
        maintainId: 0,
        maintainAddress: '',
        duration: 0,
        amount: 0,
      },
      list: [],
      duration: 0,
    }
  },
  computed: {},
  created() {
    this.queryMaintainList()
  },
  methods: {
    submitMaintain() {
      if (this.form.maintainAddress == '') {
        this.$toast.fail('请填写编号或排号')
        return
      }
      if (this.duration == 0 && this.money == 0) {
        this.$toast.fail('请选择续费年限')
        return
      }
      var that = this
      this.$submit('/api/order/addOrderWithMaintain', this.form, function(res) {
        if (res['code'] === 1) {
          that.$router.push({ path: '/shop/payok', query: { orderNo: res['data']['orderNo'] } })
        }
      })
    },
    queryMaintainList() {
      var that = this
      this.$queryAll('ProMaintain', {}, ['id', 'duration', 'price'], function(res) {
        that.$fill(that.list, res['data'])
        console.log('list:' + JSON.stringify(that.list))
      })
    },
    xuanze(id, num) {
      this.form.maintainId = id
      this.duration = num
      this.index = num
      if (num == 3) {
        this.money = 500
      }
      if (num == 5) {
        this.money = 700
      }
      if (num == 10) {
        this.money = 1000
      }
    },
    // pay() {
    //   if (!this.bianhao) {
    //     this.$toast.fail('请输入墓编号')
    //     return
    //   }
    // },
  },
  watch: {},
}
</script>

<style>
.glf {
  height: 100%;
}
.glf .van-field__control {
  text-align: right;
}
.glf .content {
  padding: 1rem;
  font-size: 1.6rem;
}
.glf .gtitle {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.glf .gtitle .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.glf .gtitle .mint-cell:last-child {
  background: none;
}

.glf .line {
  width: 100%;
  height: 1rem;
}
.glf .detailList {
  padding: 1rem;
  text-align: center;
  background-color: #15a892;
}
.glf .detailList .title {
  margin: 0.9rem 0 1rem;
  font-weight: 700;
}

.glf .detailList .menu:before {
  width: 1.5rem;
  height: 2.2rem;
  content: '';

  background-size: 1.5rem 1.5rem;
  margin-right: 0.4rem;
  display: inline-block;
  vertical-align: middle;
}
.glf .detailList .title span {
  font-size: 1.6rem;
  color: #fff;
  height: 2.2rem;
  vertical-align: middle;
  display: inline-block;
}
.glf .detailList .date {
  color: #fff;
  font-size: 2.6rem;
  margin-top: 1.5rem;
  margin-bottom: 1.4rem;
  line-height: 2.4rem;
}
.glf .detailList .text {
  color: #fff;
  margin: 0 0 0.9rem;
  font-size: 1.4rem;
}
.glf .gtitle {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.glf .gtitle .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.glf .clearbox:after,
.clearbox:before {
  content: ' ';
  display: table;
}

.glf .content {
  padding: 1rem;
  font-size: 1.6rem;
}

.glf .clearbox:after,
.clearbox:before {
  content: ' ';
  display: table;
}
.glf .clearbox:after {
  clear: both;
}
.glf .clearbox:after,
.clearbox:before {
  content: ' ';
  display: table;
}
.glf .gtitle ul.list > li.hui {
  background-color: #eee;
}

.glf .gtitle ul.list > li {
  padding: 0.8rem 0;
  line-height: 2.2rem;
  text-align: center;
  border: 1px solid #eee;
  margin-bottom: 1rem;
  float: left;
  width: calc((100% - 1.2rem) / 3);
}
.glf .gtitle .name {
  font-size: 1.4rem;
  color: #999;
}
.glf .gtitle .name1 {
  color: #fff;
}
.glf .gtitle ul.list > li.hui :hover {
  cursor: not-allowed;
}

.glf .gtitle .price {
  font-size: 1.3rem;
  color: #15a892;
}
.glf .gtitle .price1 {
  color: #fff;
}
.glf .clearbox:after {
  clear: both;
}
.glf .clearbox:after,
.clearbox:before {
  content: ' ';
  display: table;
}
.glf .clear-box {
  clear: both;
  height: 5rem;
}
.glf .footdiv {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.glf .footdiv .jiage {
  padding-right: 1.7rem;
}
.glf .footdiv .jiage .price {
  color: #15a892;
  font-weight: bolder;
}
.glf .footdiv .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
}

.gtitle ul.list > li.hui {
  background-color: #eee;
}

.gtitle ul.list > li:nth-of-type(3n-1) {
  margin-left: 0.6rem;
  margin-right: 0.6rem;
}

.gtitle ul.list > li {
  padding: 0.8rem 0;
  line-height: 2.2rem;
  text-align: center;
  border: 1px solid #eee;
  margin-bottom: 1rem;
  float: left;
  width: calc((100% - 1.2rem) / 3);
}
.gtitle .price {
  font-size: 1.3rem;
  color: #15a892;
}
</style>
